import {useEffect,useState} from 'react'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
} from '../../../../../../components/UI'
import {Column} from 'react-table'
import { TableResumen } from '../../../../../central/model'

const TableUploadPointShowDetails = ({response}: PropsA) => {
  const {data, setData, loading, setLoading} = useKTable()
  const [header,setHeader] = useState<string[] | any>([])
  useEffect(() => {
    if(response.length>0){
      let getHeader= Object.values(response[0])
      response.shift();
      setData(response)
      setHeader(getHeader)
    }
   
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns: Column<TableResumen>[] = header?.map((title:string, index:any) => {
    const column: Column<any> = {
      Header: (props) => (
        <KTableHeader tableProps={props} title={title} size='200px' />
      ),
      accessor: `Column${index}`,
    };

    return column;
  });

  useEffect(() => {
    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  return (
    <>
      <KTCard shadow>
        <KTable data={data} columns={columns} showPagination={false}/>
        {loading ? <KTableLoading title='Cargando...' /> : null}
      </KTCard>
    </>
  )
}

interface PropsA {
  response: TableResumen[]
}

const TableUploadPointShowDetailsWrapper = ({response}: PropsA) => {
  return (
    <KTableProvider>
      <TableUploadPointShowDetails response={response} />
    </KTableProvider>
  )
}

export {TableUploadPointShowDetailsWrapper}
